import type { RouteObject } from 'react-router';
import { AuthRoute } from './AuthRoute';
import { ConfirmEmailPage } from './pages/ConfirmEmailPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { VerifyEmailPage } from './pages/VerifyEmailPage';

/**
 * Auth routes, in two kinds.
 *
 * Sign-in, registration and "forgot password" are a DIALOG. These paths exist
 * only so an old link or a bookmark still works — see AuthRoute.
 *
 * The token flows are PAGES, and stay pages. They arrive from a link in an inbox,
 * often in a different browser with no session and no history to return to;
 * there is nothing behind them for a modal to sit over, and the address is the
 * whole payload.
 */
export const authRoutes: RouteObject[] = [
  { path: 'login', element: <AuthRoute mode="login" /> },
  { path: 'register', element: <AuthRoute mode="register" /> },
  { path: 'forgot-password', element: <AuthRoute mode="forgot" /> },

  { path: 'verify-email', element: <VerifyEmailPage /> },
  { path: 'reset-password', element: <ResetPasswordPage /> },
  { path: 'confirm-email', element: <ConfirmEmailPage /> },
];
